import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useBarCodeMasterStore } from "../../../store/useBarCodeStore";
import { useBarcodeStore } from "../../../store/useBarcodeMasterStore";

const BasicGrid = ({}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { masterList } = useBarcodeStore();

  const { startEdit } = useBarCodeMasterStore();

  const handleCommandClick = (args) => {
    if (args.commandColumn.type === "Edit") {
      startEdit(args.rowData);
    }
  };

  const userCommands = [
    {
      type: "Edit",
      buttonOption: {
        cssClass: "e-flat",
        iconCss: "e-edit e-icons",
      },
    },
  ];
  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={masterList}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              commandClick={handleCommandClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"400px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              // frozenColumns={1}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="Id"
                  headerText="Id"
                  width="90"
                  textAlign="Center"
                  visible={false}
                />
                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="230"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="DepartmentName"
                  headerText="Department Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GRN_91_120"
                  headerText="GRN_91_120"
                  width="160"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GRN_121_180"
                  headerText="GRN_121_180"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GRN_181_270"
                  headerText="GRN_181_270"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GRN_271_360"
                  headerText="GRN_271_360"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GRN_361_720"
                  headerText="GRN_361_720"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UPDATED_ON"
                  headerText="UPDATED_ON"
                  width="170"
                  textAlign="Left"
                />

                <ColumnDirective
                  headerText="Actions"
                  commands={userCommands}
                  width="120"
                  textAlign="Center"
                  // freeze="Right"
                />
              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BasicGrid;
